<template>
  <div class="cp-animation-renault">
    <div
      id="canvas"
    />
    <div class="gradient">
      <img
        :src="background"
        crossorigin="anonymous"
      >
    </div>
  </div>
</template>

<script>
import { Curtains, Plane } from 'curtainsjs';

export default {
  props: {
    background: {
      type: String,
      required: true,
    },
    strengthXX: {
      required: true,
      default: '4.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0
      },
    },
    strengthXY: {
      required: true,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0
      },
    },
    strengthYX: {
      required: true,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0
      },
    },
    strengthYY: {
      required: true,
      default: '2.0',
      validator(value) {
        return parseFloat(value.match(/^-?\d*(\.\d+)?$/)) > 0
      },
    },
  },

  computed: {
    getStrengthXX() {
      const val = parseFloat(this.strengthXX);
      if (Number.isInteger(val)) {
        return val.toFixed(1)
      }
      return val
    },
    getStrengthXY() {
      const val = parseFloat(this.strengthXY);
      if (Number.isInteger(val)) {
        return val.toFixed(1)
      }
      return val
    },
    getStrengthYX() {
      const val = parseFloat(this.strengthYX);
      if (Number.isInteger(val)) {
        return val.toFixed(1)
      }
      return val
    },
    getStrengthYY() {
      const val = parseFloat(this.strengthYY);
      if (Number.isInteger(val)) {
        return val.toFixed(1)
      }
      return val
    },
  },

  mounted() {
    /* eslint-disable */
    window.addEventListener('load', () => {

      /* curtainsjs converts dom elements in textured planes */
      const curtains = new Curtains({
        container: 'canvas',
        watchScroll: false,
        antialias: true,
        alpha: false,
      });

      /* vertex shader */
      const vs = `
        #ifdef GL_ES
          precision mediump float;
        #endif

        // those are the mandatory attributes that the lib sets
        attribute vec3 aVertexPosition;
        attribute vec2 aTextureCoord;

        // those are mandatory uniforms that the lib sets and that contain our model view and projection matrix
        uniform mat4 uMVMatrix;
        uniform mat4 uPMatrix;

        // our texture matrix uniform (this is the lib default name, but it could be changed)
        uniform mat4 uTextureMatrix0;

        // if you want to pass your vertex and texture coords to the fragment shader
        varying vec3 vVertexPosition;
        varying vec2 vTextureCoord;

        void main() {
          vec3 vertexPosition = aVertexPosition;

          gl_Position = uPMatrix * uMVMatrix * vec4(vertexPosition, 1.0);

          // set the varyings
          // thanks to the texture matrix we will be able to calculate accurate texture coords
          // so that our texture will always fit our plane without being distorted
          vTextureCoord = (uTextureMatrix0 * vec4(aTextureCoord, 0.0, 1.0)).xy;
          vVertexPosition = vertexPosition;
        }
      `

      /* fragment shader */
      const fs = `
        #ifdef GL_ES
          precision mediump float;
        #endif

        // get our varyings
        varying vec3 vVertexPosition;
        varying vec2 vTextureCoord;

        // the uniform we declared inside our javascript
        uniform float uTime;

        // our texture sampler (default name, to use a different name please refer to the documentation)
        uniform sampler2D uSampler0;

        void main() {
          // get our texture coords
          vec2 textureCoord = vTextureCoord;

          // displace our pixels along both axis based on our time uniform and texture UVs
          // this will create a kind of water surface effect
          // try to comment a line or change the constants to see how it changes the effect
          // reminder : textures coords are ranging from 0.0 to 1.0 on both axis
          const float PI = 3.141592;

          textureCoord.x += (
            sin(textureCoord.x * ${this.getStrengthXX} + (((uTime * 0.3) * (PI / 3.0)) * 0.031))
            + sin(textureCoord.y * ${this.getStrengthXY} + (((uTime * 0.3) * (PI / 2.489)) * 0.017))
            ) * .2;

          textureCoord.y += (
            sin(textureCoord.y * ${this.getStrengthYX} + (((uTime * 0.2) * (PI / 2.023)) * 0.023))
            + sin(textureCoord.x * ${this.getStrengthYY} + (((uTime * 0.2) * (PI / 3.1254)) * 0.037))
            ) * 0.015;

          gl_FragColor = texture2D(uSampler0, textureCoord);
        }
      `

      const params = {
        vertexShader: vs,
        fragmentShader: fs,
        widthSegments: 20,
        heightSegments: 20,
        uniforms: {
          time: { // time uniform that will be updated at each draw call
            name: "uTime",
            type: "1f",
            value: 0,
          },
        }
      };

      const plane = new Plane(curtains, document.querySelector('.gradient'), params);

      plane.onRender(() => {
        plane.uniforms.time.value++;
      })
      
    })
    /* eslint-enable */
  },
}
</script>
